import React from 'react'

const Blogs = () => {
  return (
    <div>
        <section className="welcome_area blog" id="home">
        <div className="container">
          <div className="row align-items-center">
             
            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">
                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge"> Blogs</p>
                    </div>
                    <span className="integration-text">
                      Get Realtime payments &amp; grow your business!
                    </span>
                  </div>
                </div>
                <h1 className="b-text bold">
                  Transfer Money Across The World In Real Time.
                </h1>
                <p>
                  We have over 15 year exprience in Payment consultting arena. We have
                  over 15 year exprience in Payment consultting arena and artficial
                  intelligence.
                </p>
                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="contact.html" className="btn more-btn mr-3">
                    contact us
                  </a>
                  <a className="btn more-btn" href="services.html">
                     
                    Apply For Loan
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6"></div>
          </div>
        </div>
      </section>
      
    </div>
  )
}

export default Blogs
